import { useFields as useProfessionalContactFields } from '../fields/professionalContactFields';

/**
 * A custom hook that returns an array of field objects to be used in a veterinarian form.
 *
 * @returns {Object} - An object containing a fields array with configurations for form fields.
 *
 * @example
 * const { fields } = useFields();
 */
export const useFields = () => useProfessionalContactFields('veterinarian');
